import { render } from "./ProxyPlayer.vue?vue&type=template&id=13be73fa&scoped=true"
import script from "./ProxyPlayer.vue?vue&type=script&lang=js"
export * from "./ProxyPlayer.vue?vue&type=script&lang=js"

import "./ProxyPlayer.vue?vue&type=style&index=0&id=13be73fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13be73fa"]])

export default __exports__